"use client";

import React, { useEffect } from "react";
import { Snackbar, Alert, CircularProgress } from "@mui/material";
import { useToast } from "./toastHooks";
import { setToastFunctions } from "@/app/utils/functions";

export const ToastProvider = () => {
  const {
    open,
    message,
    severity,
    canClose,
    autoHide,
    autoHideDuration,
    showToast,
    showLoading,
    hideToast,
  } = useToast();

  useEffect(() => {
    setToastFunctions({
      showToast,
      showLoading,
      hideToast,
    });
  }, [showToast, showLoading, hideToast]);

  return (
    <Snackbar
      key={message}
      open={open}
      autoHideDuration={autoHide ? autoHideDuration : null}
      onClose={hideToast}
    >
      <Alert
        onClose={canClose ? hideToast : null}
        variant="outlined"
        severity={severity == "loading" ? "info" : severity}
        sx={{ width: "100%", background: "white", fontSize: "16px", fontWeight: "500" }}
        icon={
          severity == "loading" ? <CircularProgress size={20} /> : undefined
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
